'use client'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getProductDetailDoc } from '@vendure/hub/data-access'
import { oneClickCheckout } from '@vendure/hub/data-access/server'
import { toast } from '@vendure/shadcn/ui'
import { ResultOf } from 'gql.tada'
// @ts-ignore
import { GraphQLResponse } from 'graphql-request/build/esm/types'
import { usePathname, useRouter } from 'next/navigation'
import { useState } from 'react'
import { buyNowOrSignIn } from './actions'
import { AddToCardButton } from './add-to-card-button'
import { SubscriptionPlanSelector } from './subscription-plan-selector'

type Props = {
  product: ResultOf<typeof getProductDetailDoc>['product']
}

export function AddToCart({ product }: Props) {
  const productVariant = product?.variants[0]
  const router = useRouter()
  const path = usePathname()
  const queryClient = useQueryClient()

  const [selectedSubscriptionPlanId, setSelectedSubscriptionPlanId] = useState<
    string | undefined
  >(undefined)

  const oneClickCheckoutMutation = useMutation({
    mutationFn: oneClickCheckout,
    onSuccess: async (result, variables) => {
      if (result.oneClickCheckout) {
        await queryClient.invalidateQueries({ queryKey: ['activeOrder'] })
        window.location.href = result.oneClickCheckout
      }
    },
    onError: (error: GraphQLResponse) => {
      const message = error.errors?.at(0)?.message || 'An error occurred'
      toast({
        title: 'An error occurred',
        variant: 'destructive',
        description: message,
      })
    },
  })

  const subscriptionPlans = productVariant?.subscriptionPlans ?? []
  if (!selectedSubscriptionPlanId && subscriptionPlans.length) {
    setSelectedSubscriptionPlanId(subscriptionPlans[0]?.id)
  }

  const buyNowOrSignInWithVariantAndPlanId = buyNowOrSignIn.bind(
    null,
    productVariant?.id,
    selectedSubscriptionPlanId,
  )

  return (
    <form
      action={buyNowOrSignInWithVariantAndPlanId}
      className="add-to-cart"
    >
      <SubscriptionPlanSelector
        selectedPlanId={selectedSubscriptionPlanId}
        subscriptionPlans={subscriptionPlans}
        onSelectionChange={(planId) => setSelectedSubscriptionPlanId(planId)}
      />
      <div className="mt-4 flex justify-end">
        <AddToCardButton />
      </div>
    </form>
  )
}
